import React from 'react';
import { SearchIcon, MessageSquareIcon, FileTextIcon, DatabaseIcon, ScaleIcon } from 'lucide-react';
interface SidebarProps {
  activePage: 'discovery' | 'ask' | 'deposition';
  setActivePage: (page: 'discovery' | 'ask' | 'deposition') => void;
}
export function Sidebar({
  activePage,
  setActivePage
}: SidebarProps) {
  const navItems = [{
    id: 'discovery',
    label: 'Discovery',
    icon: SearchIcon
  }, {
    id: 'ask',
    label: 'Ask',
    icon: MessageSquareIcon
  }, {
    id: 'deposition',
    label: 'Deposition',
    icon: FileTextIcon
  }] as const;
  return <div className="w-[220px] bg-[#0A1520] border-r border-navy-border flex flex-col h-screen flex-shrink-0" data-id="element-175">
      <div className="p-4 border-b border-navy-border flex items-center gap-2" data-id="element-176">
        <div className="bg-accent-amber text-navy p-1 rounded-sm" data-id="element-177">
          <ScaleIcon size={18} className="stroke-[2.5]" data-id="element-178" />
        </div>
        <span className="font-bold text-lg tracking-tight text-white" data-id="element-179">
          Geniac
        </span>
      </div>

      <div className="px-3 py-4 flex-1 flex flex-col gap-1" data-id="element-180">
        <div className="text-xxs font-semibold text-text-muted uppercase tracking-wider mb-2 px-2" data-id="element-181">
          Workbench
        </div>

        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = activePage === item.id;
        return <button key={item.id} onClick={() => setActivePage(item.id)} className={`flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium transition-colors text-left w-full
                ${isActive ? 'bg-navy-surface text-white border-l-2 border-accent-amber pl-[10px]' : 'text-text-secondary hover:bg-navy-surface hover:text-white border-l-2 border-transparent pl-[10px]'}`} data-id="element-182">
              <Icon size={16} className={isActive ? 'text-accent-amber' : 'text-text-muted'} data-id="element-183" />
              {item.label}
            </button>;
      })}
      </div>

      <div className="p-3 border-t border-navy-border" data-id="element-184">
        <button className="flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium text-text-muted hover:text-text-secondary hover:bg-navy-surface transition-colors w-full text-left" data-id="element-185">
          <DatabaseIcon size={16} data-id="element-186" />
          Sources
        </button>
      </div>
    </div>;
}